import { MapGroupId } from "../../types";
import img from "../../mapImages/WoodsCaches.webp";

const mapData = {
  groupId: MapGroupId.Woods,
  groupName: {
    en: "Woods",
    ru: "Лес ",
  },
  title: {
    en: "Caches",
    ru: "Тайники",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
